<script lang="ts">
import { FunctionalComponentOptions } from 'vue';
import VsButton from '@/scripts/Components/Molecules/VsButton.vue';
import FooterActionStyle from './FooterAction/style.module.scss';

export default {
  functional: true,
  render: (h, context) => h(
    VsButton,
    {
      props: context.props,
      on: context.listeners,
      class: FooterActionStyle.button,
    },
    [
      ...context.slots().default ?? [],
    ],
  ),
} as FunctionalComponentOptions;
</script>
